
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import GradientInput from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/GradientInput.vue";

@Component({
  components: {
    GradientInput
  }
})
export default class RGBItem extends Vue {
  @Prop()
  value!: string | number;

  @Prop()
  type!: string;

  @Prop()
  label!: string;

  @Prop()
  onChange!: Function;

  inputValue = this.value;
  inProgress = false;

  @Watch("value")
  onValueChange() {
    this.setValue();
  }

  onChangeHandler(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = +target.value;

    if (Number.isNaN(value) || value < 0 || value > 255) {
      this.inputValue = this.value;
      this.$forceUpdate();
      return;
    }

    this.inputValue = target.value;
    this.onChange(value);
  }

  onBlur() {
    if (!this.inputValue && this.inputValue !== 0) {
      this.inputValue = this.value;
    }

    this.inProgress = false;
  }

  setValue() {
    if (this.value !== +this.inputValue && this.inputValue !== "") {
      this.inputValue = this.value;
    }
  }
}
